import { render } from "./Index.vue?vue&type=template&id=1be85976&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1be85976&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=1be85976&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be85976"]])

export default __exports__